'use client';

import { useState, useEffect } from 'react';
import {
  doc,
  getDoc,
  DocumentData,
  FirestoreError,
} from 'firebase/firestore';
import { useFirestore } from '@/firebase/provider';

export function useUserById(uid: string | null | undefined) {
  const [data, setData] = useState<DocumentData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<FirestoreError | null>(null);
  const firestore = useFirestore();

  useEffect(() => {
    setIsLoading(true);
    setData(null);
  }, [uid]);

  useEffect(() => {
    if (!uid || !firestore) {
      setIsLoading(false);
      return;
    }

    const fetchUser = async () => {
      setError(null);
      try {
        const userDocRef = doc(firestore, 'users', uid);
        const snap = await getDoc(userDocRef);
        if (snap.exists()) {
          setData({ ...snap.data(), id: snap.id });
        } else {
          setData(null);
        }
      } catch (err) {
        setError(err as FirestoreError);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUser();
  }, [uid, firestore]);

  return { data, isLoading, error };
}
